import { none } from 'fp-ts/lib/Option'
import React from 'react'

import NavDropdown from './NavDropdown'
import NavLink from './NavLink'
import type { MainMenuProps, NavLinkProps, SimpleMenuProps } from './schema'

const isMenu = (el: NavLinkProps | SimpleMenuProps): el is SimpleMenuProps =>
  el.__typename === 'Menu'

export default function DesktopNavMenu({
  menu
}: {
  readonly menu: MainMenuProps
}) {
  const { links } = menu

  return (
    <nav
      aria-label="Links bar"
      className="hidden h-full items-center justify-between gap-6 justify-self-start lg:flex"
    >
      {links.items.map((element, index) =>
        !isMenu(element) ? (
          <NavLink
            className="hover:text-primary-100 text-white"
            key={`Desktop-nav-link-${index}`}
            trackingLabel={none}
            {...element}
          />
        ) : (
          <NavDropdown key={`Desktop-nav-dropdown-${index}`} {...element} />
        )
      )}
    </nav>
  )
}
